// Lodash
import { get } from 'lodash';

// STORE ACTION AND STATE
import { Actions, ActionTypes } from './actions';
import { initialState, UserState } from './state';
import { Actions as AuthActions, ActionTypes as AuthActionTypes } from '../../auth/store/actions';


/**
 * This effect is for listen user actions, execute user service call and dispatch in user reducer.
 * For user api call purpose.
 *
 * @author Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 01-05-2020(Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>)  created user effect
 */
export function reducer(state = initialState, action: Actions | AuthActions): UserState {
  switch (action.type) {
    // user COMMON METHOD
    case ActionTypes.USER_COMMON: {
      return state;
    }
    // user Success COMMON METHOD
    case ActionTypes.USER_COMMON_SUCCESS: {
      // commonly store and handle all user modules
      if (action.response && action.response.common && action.response.common.API_RESPONSE) {
        return {
          ...state,
          [action.response.common.STATE]: get(action.response.data, action.response.common.API_RESPONSE),
        };
      } else {
        return {
          ...state,
          [action.response.common.STATE]: action.response.data,
        };
      }
    }

    // CLEAR_REDUCER METHOD ON LOGOUT
    case AuthActionTypes.CLEAR_REDUCER: {
      return initialState;
    }

    // CLEAR_BUSINESS_REDUCER METHOD ON BUSINESS CHANGE
    case AuthActionTypes.CLEAR_BUSINESS_REDUCER: {
      return {
        ...state,
        common: null,
      };
    }

    // DEFAULT
    default:
      return state;
  }
}
